import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useLocationCache } from '../location/cache'
import { useTantalimMutation } from '../mutation'
import { type OnLocationMutate } from './types'
import {
  type ExtendedLocationData,
  type LocationNoteUpdateInput,
  type LocationNoteUpdateSuccess,
  Logger,
  toResponseError,
} from '@terros/common'

const logger = new Logger('note')

export function useUpdateLocationNote(
  onMutate: OnLocationMutate
): UpdateHookResponse<LocationNoteUpdateInput, ExtendedLocationData> {
  logger.verbose('calling useUpdateLocationNote')
  const { replaceItem } = useLocationCache()

  const mutation = useTantalimMutation<LocationNoteUpdateInput, LocationNoteUpdateSuccess>({
    url: '/location/note/update',
  })

  async function update(input: LocationNoteUpdateInput): Promise<ExtendedLocationData> {
    const { locationId } = input
    try {
      logger.verbose('starting update')
      const output = await mutation.mutateAsync({ version: 3, ...input })
      const { location: newLocationData } = output
      replaceItem(locationId, newLocationData)
      await onMutate(locationId, newLocationData.locationId)
      logger.verbose('done with update')
      return output.location
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
